import { useNavigate } from "react-router-dom";
import Overlay from "../../Componentes/Overlay";
import SideMenu from "../../Componentes/SideMenu";
import SideMenuBtn from "../../Componentes/SideMenuBtn";

export default function SidebarInventarioTI({
  onClose,
  onNovoEquipamento,
  onNovoTipoAtivo,
  onOnboardColaborador,
  onOffboardColaborador,
  onGerarTermos,
  onGerarRelatorio,
  loadingRelatorio,
}) {
  const navigate = useNavigate();

  const handleLicencasColaboradores = () => {
    onClose();
    navigate("/modulo/inventario-ti/licencas-colaboradores");
  };

  return (
    <Overlay state={true} changeContent={onClose}>
      <SideMenu>
        <SideMenuBtn
          button="LICENÇAS X COLABORADORES"
          clickFunc={handleLicencasColaboradores}
        />
        <SideMenuBtn button="ONBOARD COLABORADOR" clickFunc={onOnboardColaborador} />
        <SideMenuBtn button="OFFBOARD COLABORADOR" clickFunc={onOffboardColaborador} />
        <SideMenuBtn button="GERAR TERMOS" clickFunc={onGerarTermos} />
        <SideMenuBtn
          button="GERAR RELATÓRIO"
          clickFunc={onGerarRelatorio}
          isLoading={loadingRelatorio}
        />
        <SideMenuBtn button="NOVO EQUIPAMENTO" clickFunc={onNovoEquipamento} />
        <SideMenuBtn button="NOVO TIPO DE ATIVO" clickFunc={onNovoTipoAtivo} />
      </SideMenu>
    </Overlay>
  );
}